@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.velocity-chart {
  width: 100%;
  padding: @space-16;
  background-color: var(--white);

  .tooltip {
    background-color: var(--white);
    border: 1px solid var(--grey-300);
    border-radius: @space-4;
    padding: @space-8;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .tooltip-date {
    font-weight: 500;
    margin-bottom: @space-4;
    color: var(--grey-800);
  }

  .tooltip-value {
    margin: 0;
    color: var(--grey-600);
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    width: 100%;
  }
}

// No historical data styles - simplified with reused selectors
.no-data,
.velocity-chart .no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
  background-color: var(--grey-100);
  border-radius: @space-4;
  padding: @space-16;
  text-align: center;
}

.title,
.velocity-chart .no-data .title,
.no-data-title {
  margin-bottom: @space-8;
  color: var(--grey-700);
  font-weight: 500;
}

.description,
.velocity-chart .no-data .description,
.no-data-description {
  color: var(--grey-500);
}

// Chart controls styles
.chart-controls {
  display: flex;
  flex-wrap: wrap;
  gap: @space-16;
  margin-bottom: @space-16;

  .group {
    display: flex;
    align-items: center;
    gap: @space-8;
  }

  .label {
    font-weight: 500;
    color: var(--grey-700);
    white-space: nowrap;
  }

  .select {
    min-width: 120px;
  }
}
